<template>
  <div class="app-container">
    <div class="title-container">
      哈尔滨医科大学附属第六医院智能数据中心
      <span class="time">{{ currentTime }}</span>
    </div>

    <div class="content-container clearfix">
      <div class="left-panel">
        <InspectionManagement />
        <DisasterPreventionManagement />
        <RiskManagement />
      </div>
      <div class="center-panel">
        <EquipmentManagement />
        <OperationData />
        <EquipmentMaintenance />
      </div>
      <div class="right-panel">
        <MedicalWasteManagement />
        <IncidentManagement />
        <TransportManagement />
      </div>
    </div>
  </div>
</template>

<script>
import InspectionManagement from './components/InspectionManagement.vue'
import DisasterPreventionManagement from './components/DisasterPreventionManagement.vue'
import RiskManagement from './components/RiskManagement.vue'
import EquipmentManagement from './components/EquipmentManagement.vue'
import OperationData from './components/OperationData.vue'
import EquipmentMaintenance from './components/EquipmentMaintenance.vue'
import MedicalWasteManagement from './components/MedicalWasteManagement.vue'
import IncidentManagement from './components/IncidentManagement.vue'
import TransportManagement from './components/TransportManagement.vue'

export default {
  name: 'App',
  components: {
    InspectionManagement,
    DisasterPreventionManagement,
    RiskManagement,
    EquipmentManagement,
    OperationData,
    EquipmentMaintenance,
    MedicalWasteManagement,
    IncidentManagement,
    TransportManagement
  },
  data() {
    return {
      currentTime: ''
    }
  },
  mounted() {
    this.updateTime()
    setInterval(this.updateTime, 1000)
  },
  methods: {
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const weekDay = weekDays[now.getDay()]
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} (${weekDay})`
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background: url("/static/image/equip/bg.png") no-repeat center;
  background-size: cover;
  padding: 0 20px;

  .title-container {
    position: relative;
    height: 96px;
    line-height: 88px;
    text-align: center;
    color: #ffffff;
    font-size: 28px;
    font-weight: bold;
    background: url("/static/image/equip/top-bj@2x.png") no-repeat center;
    background-size: 100% 100%;

    .runDays {
      position: absolute;
      left: 0;
      width: 492px;
      margin-bottom: 0;
      font-size: 20px;
      padding-top: 6px;
      text-align: center;
    }

    .time {
      position: absolute;
      width: 18%;
      right: 0;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
      padding-top: 6px;
    }
  }

  .content-container {
    height: calc(100% - 96px);
    overflow: hidden;
    display: flex;
    gap: 15px;

    // padding: 10px;
    .left-panel {
      flex: 3;
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .center-panel {
      flex: 4;
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .right-panel {
      flex: 3;
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
  }

  .title {
    position: relative;
    color: #ffffff;
    font-size: 16px;
    height: 30px;
    line-height: 30px;
  }

  /deep/ .el-table::before {
    height: 0px;
  }

  /deep/ .el-table {
    background: transparent;

    .el-table__body {
      tr:hover>td {
        color: #022d53;
        background: #a8e6f3;
      }
    }

    .el-table__header-wrapper {
      tr {
        background-color: transparent;

        th {
          color: #ffffff;
          background-color: rgba(0, 186, 255, 0.1);
          border: none;

          &.gutter {
            background: transparent;
          }
        }
      }
    }

    .el-table__body-wrapper {
      scrollbar-width: none;

      &::-webkit-scrollbar {
        width: 0 !important;
      }

      tbody {
        tr {
          background: transparent;

          td {
            border: 1px solid #022d53;
            color: #a8e6f3;
          }
        }
      }
    }
  }
}

.clearfix {
  &::after {
    content: "";
    display: table;
    clear: both;
  }
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.mt10 {
  margin-top: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

.mb5 {
  margin-bottom: 5px;
}
</style>
